import { select, take } from 'redux-saga/effects';

import { selectors as wishlistSelectors, types as wishlistTypes } from '../../store/wishlist';

export const getWishlistCode = function*() {
    let wishlistCode = yield select(wishlistSelectors.getWishlistCode);

    if (!wishlistCode) {
        yield take(wishlistTypes.LOAD_WISHLIST);
        wishlistCode = yield select(wishlistSelectors.getWishlistCode);
    }

    return wishlistCode;
};
